import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';

declare var AOS: any;

@Component({
  selector: 'app-iiot',
  templateUrl: './iiot.component.html',
  styleUrls: ['./iiot.component.scss'],
  standalone: false
})
export class IIOTComponent implements OnInit, AfterViewInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'visionsdk', label: 'Vision SDK', icon: 'bx-chip' },
    { id: 'usecases', label: 'Use Cases', icon: 'bx-bulb' },
  ];

  highlights = [
    { icon: 'bx-chip', label: 'Edge Processing' },
    { icon: 'bx-network-chart', label: 'Multi-Protocol' },
    { icon: 'bx-shield', label: 'Industrial Security' },
    { icon: 'bx-time', label: 'Real-Time Data' },
  ];

  visionsdk = [
    { icon: 'bx-time', label: 'Enable end-to-end traceability ' },
    { icon: 'bx-camera', label: 'Real-Time Vision' },
    { icon: 'bx-chip', label: 'Edge AI' },
    { icon: 'bx-search-alt', label: 'Defect Detection' },
    { icon: 'bx-transfer', label: 'MES / ERP' },
    { icon: 'bx-network-chart', label: 'Scalable Deployment' },
    { icon: 'bx-timer', label: 'Low Latency' },
    { icon: 'bx-buildings', label: 'Industry 4.0' }
  ];


  iiot_usecases = [
    {
      icon: 'bx-tachometer',
      title: 'OEE Monitoring',
      desc: 'Track and optimize Overall Equipment Effectiveness (OEE) across plant operations.',
      points: [
        'Monitor availability, performance, and quality in real time',
        'Identify bottlenecks and downtime causes',
        'Improve production efficiency and throughput',
      ],
    },
    {
      icon: 'bx-chip',
      title: 'Edge Computing for Real-Time Decisions',
      desc: 'Enable on-site data processing for faster and more reliable decision-making.',
      points: [
        'Process critical data at the edge',
        'Reduce latency in time-sensitive operations',
        'Enable immediate response to anomalies',
      ],
    },
    {
      icon: 'bx-heart-circle',
      title: 'Asset Health Tracking',
      desc: 'Continuously monitor the condition of critical equipment.',
      points: [
        'Track parameters for pumps, motors, compressors, etc.',
        'Predict failures using real-time data',
        'Optimize maintenance schedules',
      ],
    },
    {
      icon: 'bx-bar-chart-alt-2',
      title: 'Data-Driven Decision Making',
      desc: 'Leverage data insights to improve plant operations.',
      points: [
        'Centralized dashboards for operational visibility',
        'Analytics-driven insights for optimization',
        'Performance benchmarking across assets and plants',
      ],
    },
    {
      icon: 'bx-line-chart',
      title: 'Predictive Maintenance',
      desc: 'Continuously monitor equipment health and predict failures before they impact production.',
      points: [
        'Identify performance deviations in real time',
        'Schedule maintenance proactively',
        'Increase equipment uptime and productivity',
      ],
    }
  ];


  vision_sdk_usecases = [
    {
      icon: 'bx-search-alt',
      title: 'Automated Visual Inspection',
      desc: 'AI-powered inspection for defect detection and quality assurance.',
      points: [
        'Surface defect detection',
        'Assembly validation',
        'Dimensional verification'
      ]
    },
    {
      icon: 'bx-qr-scan',
      title: 'Traceability & Identification',
      desc: 'Product-level traceability using intelligent vision systems.',
      points: [
        'Barcode & QR scanning',
        'OCR & serial number capture',
        'Configuration validation'
      ]
    },
    {
      icon: 'bx-palette',
      title: 'Color & Pattern Detection',
      desc: 'Ensure correct product variants and visual consistency.',
      points: [
        'Color validation',
        'Variant verification',
        'Label inspection'
      ]
    },
    {
      icon: 'bx-cube',
      title: 'Component & Assembly Inspection',
      desc: 'Verify structural integrity and assembly correctness.',
      points: [
        'Alignment checks',
        'Missing component detection',
        'Geometry validation'
      ]
    },
    {
      icon: 'bx-brain',
      title: 'Intelligent Vision Analytics',
      desc: 'Advanced AI perception for dynamic industrial environments.',
      points: [
        'Object detection & tracking',
        'Risk & anomaly alerts',
        'Behavioral analytics'
      ]
    },
    {
      icon: 'bx-shield-quarter',
      title: 'Safety & Compliance Monitoring',
      desc: 'Improve workplace safety using real-time AI vision.',
      points: [
        'PPE compliance',
        'Restricted zone monitoring',
        'Incident detection'
      ]
    }
  ];
  ngOnInit() { }

  ngAfterViewInit() {
    try { AOS.refresh(); } catch (e) { }
  }

  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
